require('./collapsableMenuDirective');

"use strict";

angular.module('app.mainFrame.collapsableMenu', [
    'app.mainFrame.collapsableMenu.collapsableMenuDirective'
]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/collapsableMenu/collapsableMenu.js